
import qs from "qs"
import {Dialog, Toast} from 'vant';
import {mapActions} from "vuex";

export default {
  name: "production",
  data() {
    return {
      Programs: [],
      programId: "",
      pageNum: 1,
      classify: [],
      active: 0,
      activeName: 0,
    }
  },
  async mounted() {
    await this.getClassify()
    await this.getPrograms()
  },
  methods: {
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
    getPrograms() {
      this.$ajax.post("/etv/selectH5PageProgramMouldInfo.json", qs.stringify({
        pcId: this.classify[this.active].id,
        state: "0",
        name: "",
        pageNum: this.pageNum,
        pageSize: 99999,
      })).then(res => {
        if (res.data.code === 0) {
          this.Programs = res.data.data.pmList
          this.count = Math.ceil(res.data.data.totalNum / 10)
        }
      })
    },
    async getClassify() {
      await this.$ajax.post("/etv/selectH5ProgramCategoryAlls.json").then(res => {
        if (res.data.code === 0) {
          this.classify = res.data.data.pcList
          this.classify.map(res => {
            res.name = res.name.split("(")[0]
          })
        }
      })
    },
    getClassifyContent(id) {
      this.active = id
      this.getPrograms()
    },
    getpage(i) {
      this.pageNum = i
      this.getPrograms()
    },
    onDeleteProgram(id, index) {
      this.programId = id
      Dialog.confirm({
        title: this.$t('append_field.deleteP'),
        message: this.$t('append_field.con_P'),
      }).then(() => {
        this.deletePrograms(id, index)
      }).catch(() => {
      })
    },
    deletePrograms(id, index) {
      this.$ajax({
        url: '/etv/deleteProgramMouldById.json',
        method: 'post',
        data: qs.stringify({id: id})
      }).then(res => {
        let code = res.data.code
        let msg = res.data.msg
        if (code === 0) {
          Toast({type: 'success', message: this.$t('append_field.delete_success'), duration: 1000})
          this.Programs.splice(index, 1)
        } else {
          Toast(msg)
        }
      })
    },
    onEmploy(id) {
      this.$router.push({
        path: `/h5Preview/${id}`,
        query: {
          type: "jm"
        }
      })
    },
    gotoa(url, query) {
      this.$router.push({
        path: url,
        query,
      })
      if (url == '/addTask') {
        this.changeTopTitle(this.$t('append_field.addTask'))
        this.setParentPage('programs')
        this.changeTopIconStatus(true)
      }
    },
  }
}
